import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'
import './ConfirmModal.scss'
import { putDataToSettingsServer } from '../../../../../apiHelper/settingsApi'
import { SETTINGS_URL } from '../../../../../apiHelper/apiRoute/settings'
import { toast } from 'react-toastify'
import { sidePanelFreeRoutes } from '../../../../../routes'
import { acceptTos } from '../../../../../redux/user/userSlice'

export default function TermsOfService() {
  const location = useLocation()
  const dispatch = useDispatch()
  const tosAccepted = useSelector((state) => state.user?.user?.tosAccepted)

  const [show, setShow] = useState(false)

  useEffect(() => {
    // only show modal on landing pages
    // only process if user store is set
    if (!sidePanelFreeRoutes.includes(location.pathname)) {
      const storedTOS = JSON.parse(localStorage.getItem('authUser') || null)?.user?.tosAccepted
      const tos = typeof tosAccepted === 'boolean' ? tosAccepted : storedTOS
      setShow(!Boolean(tos))
    }
  }, [tosAccepted, location.pathname])

  return (
    <CModal
      className="confirm-modal"
      visible={show}
      fullscreen={'xxl'}
      keyboard={false}
      alignment={'center'}
      backdrop={'static'}
      onClose={() => setShow(false)}
    >
      <CModalHeader className="d-flex" closeButton={false}>
        Terms of Service
      </CModalHeader>
      <CModalBody>
        <div style={{ textAlign: 'center' }}>
          <div>Please read and accept the Terms of Service</div>
          <a
            href={'https://claimocity.com/terms-of-service/'}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton
          color="primary"
          onClick={() => {
            putDataToSettingsServer(SETTINGS_URL.ACCEPT_TOS)
              .then(() => {
                dispatch(acceptTos())
              })
              .catch((e) => {
                console.error(e)
                toast.error('Unable to accept TOS')
              })
          }}
        >
          Accept
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
